import { colors } from '_/space-management/constants/theme';
import { t } from 'i18next';
import { MutableRefObject } from 'react';
import { showMessage } from 'react-native-flash-message';

export function networkErrorMessage(error: any, modalRef?: MutableRefObject<any>) {
  const message = {
    message: t('spaceManage.error'),
    description: t('spaceManage.connectionIsUnstable'),
    backgroundColor: colors.errorRed,
  };

  if (error.message === 'Network Error') {
    if (modalRef) {
      modalRef?.current?.showMessage(message);
    }
    showMessage(message);

    throw error;
  }
}
